import ContaPagar from "./contaPagar/ContaPagar";
import ItemExtrato from "./extrato/ItemExtrato";

export default class BuscaDetalhada {
    contasPagar : ContaPagar[];
	itensExtrato : ItemExtrato[];

    constructor(contasPagar: ContaPagar[], itensExtrato: ItemExtrato[]) {
        this.contasPagar = contasPagar;
        this.itensExtrato = itensExtrato;
    }
}